import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import {
  CURD_L3_MENU_PERMISSIONS_CHR,
  GET_L3_MENU_PERMISSIONS_ROLE_CHR,
  CURD_L3_SERVICE_PERMISSIONS_CHR,
  GET_L3_SERVICE_PERMISSIONS_ROLE_CHR,
} from "../../../../utils/routes";

// ---------------------------------------------------------------------

export const createL3MenuPermissionChr = createAsyncThunk(
  "l3AccessPermission/createL3MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L3_MENU_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL3MenuPermissionChr = createAsyncThunk(
  "l3AccessPermission/getL3MenuPermissionChr",
  async () => {
    return axios.get(CURD_L3_MENU_PERMISSIONS_CHR, { withCredentials: true });
  }
);

export const getL3MenuPermissionChrRole = createAsyncThunk(
  "l3AccessPermission/getL3MenuPermissionChrRole",
  async (id) => {
    return axios.get(`${GET_L3_MENU_PERMISSIONS_ROLE_CHR}/${id}`, {
      withCredentials: true,
    });
  }
);

export const updateL3MenuPermissionChr = createAsyncThunk(
  "l3AccessPermission/updateL3MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L3_MENU_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL3MenuPermissionChr = createAsyncThunk(
  "l3AccessPermission/deleteL3MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L3_MENU_PERMISSIONS_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createL3ServicePermissionChr = createAsyncThunk(
  "l3AccessPermission/createL3ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L3_SERVICE_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL3ServicePermissionChr = createAsyncThunk(
  "l3AccessPermission/getL3ServicePermissionChr",
  async () => {
    return axios.get(CURD_L3_SERVICE_PERMISSIONS_CHR, { withCredentials: true });
  }
);

export const getL3ServicePermissionRoleChr = createAsyncThunk(
  "l3AccessPermission/getL3ServicePermissionRoleChr",
  async (id) => {
    return axios.get(`${GET_L3_SERVICE_PERMISSIONS_ROLE_CHR}/${id}`, {
      withCredentials: true,
    });
  }
);

export const updateL3ServicePermissionChr = createAsyncThunk(
  "l3AccessPermission/updateL3ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L3_SERVICE_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL3ServicePermissionChr = createAsyncThunk(
  "l3AccessPermission/deleteL3ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L3_SERVICE_PERMISSIONS_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const l3AccessPermissionSlice = createSlice({
  name: "l3AccessPermission",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    l3MenuPermissionData: [],
    l3MenuPermissionChrData : [],
    l3MenuSelectedData: {},
    l3ServicePermissionData: [],
    l3ServiceSelectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    l3MenuRowSelect: (state, action) => {
      state.l3MenuSelectedData =
        action?.payload.length > 0 && action?.payload[0];
    },
    l3ServiceRowSelect: (state, action) => {
      state.l3ServiceSelectedData =
        action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createL3MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL3MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL3MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL3MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL3MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l3MenuPermissionData = action?.payload?.data;
    },
    [getL3MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [getL3MenuPermissionChrRole.pending]: (state, action) => {
      state.loading = true;
    },
    [getL3MenuPermissionChrRole.fulfilled]: (state, action) => {
      state.loading = false;
      state.l3MenuPermissionChrData = action?.payload?.data;
    },
    [getL3MenuPermissionChrRole.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL3MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL3MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL3MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL3MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL3MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL3MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [createL3ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL3ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL3ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL3ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },

    [getL3ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l3ServicePermissionData = action?.payload?.data;
    },
    [getL3ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [getL3ServicePermissionRoleChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL3ServicePermissionRoleChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l3ServicePermissionData = action?.payload?.data;
    },
    [getL3ServicePermissionRoleChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL3ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL3ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL3ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL3ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL3ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL3ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const {
  resetMessage,
  resetErrMessage,
  l3MenuRowSelect,
  l3ServiceRowSelect,
} = l3AccessPermissionSlice.actions;
export default l3AccessPermissionSlice.reducer;
